<template>
    <div>
        <DCard
            padding
        >
            <NotesForm
                :customer-note="customerNote"
                :errors="errors"
                @submit="storeNote"
            />
        </DCard>
        <DCard
            :title="__('customers.customers.customer_notes_title')"
            padding
            class="customer-notes-margin"
        >
            <template #default>
                <div
                    v-for="customerNoteElement in customerNotes"
                    :key="customerNoteElement.id"
                    class="customer-notes"
                >
                    <div class="header">
                        <span>{{ setDateFormat(customerNoteElement.createdAt, 'YYYY-MM-DD hh:mm') }}</span>
                    </div>
                    <div class="body">
                        <div>
                            <NoteContent :note-parts="customerNoteElement.note" />
                        </div>
                    </div>
                </div>
            </template>
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import NotesForm from '~@/Components/Customers/Notes/Form'
import NoteContent from '~@/Components/Customers/NoteContent'

export default {
    name: 'CustomerNotesCreate',
    components: {
        NoteContent,
        NotesForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        customerId: {
            type: Number,
            default: 0
        },
        customerNotes: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
            customerNote: { customerId: this.customerId }
        }
    },
    methods: {
        storeNote (form) {
            form.post(this.$route('customers.customers.customer-notes.store', {
                customer: this.customerId
            }))
        }
    }
}
</script>

<style lang="scss" scoped>
.customer-notes {
    padding: 15px;

    &:not(:last-child) {
        border-bottom: 1px solid #D9DBE0;
    }

    & .header {
        display: grid;
        grid-template-columns: 1fr auto;
        margin-bottom: 10px;

        & span:nth-child(1) {
            font-weight: bold;
        }
    }

    & .body {
        display: grid;
        grid-template-columns: 1fr auto;
        word-break: break-all;

        & div:nth-child(1) {
            line-height: 1.5em;
        }
    }
}

.customer-notes-margin {
    margin-top: 25px;
}
</style>
